<template>
  <a-layout-header class="header">
    <div class="title">
      <span class="head-title">
        <span>{{ pageTitle }}</span>
      </span>

      <div class="user-info">
        <span class="menu-item" @click="fullScreen">
          <a-icon
            type="fullscreen-exit"
            style="font-size: 20px"
            title="退出全屏"
            v-show="fullscreen"
          />
          <a-icon
            type="fullscreen"
            style="font-size: 20px"
            title="全屏"
            v-show="!fullscreen"
          />
        </span>

        <span v-if="isTouchMode" class="menu-item" @click="toClickMode">
          <i
            title="鼠标模式"
            style="font-size: 20px"
            class="iconfont iconClick"
          ></i>
        </span>
        <span v-else class="menu-item" @click="toTouchMode">
          <i
            title="触屏模式"
            style="font-size: 20px"
            class="iconfont iconTouch"
          ></i>
        </span>
        <!-- <span title="设置" class="menu-item" @click="handleClick">
          <a-icon type="setting" />
        </span> -->
        <a-dropdown>
          <a-menu slot="overlay">
            <!-- 修改密码 -->
            <a-menu-item
              v-if="isShowUpdatePassword"
              key="1"
              @click="updatePassword"
              >{{ $t("message.label_update_password") }}</a-menu-item
            >
            <!-- 修改口令 -->
            <!-- <a-menu-item key="2">{{
              $t("message.label_update_key")
            }}</a-menu-item> -->
            <a-menu-item
              v-if="isShowProjectConfig"
              key="2"
              @click="enterConfigPage"
              >{{ $t("message.label_project_config") }}</a-menu-item
            >
            <a-menu-item @click="logout" key="3">{{
              $t("message.label_sign_out")
            }}</a-menu-item>
          </a-menu>
          <span class="menu-item"
            ><img
              style="margin: 0 4px 4px 0"
              :src="require('../../../assets/icon/user.png')"
            /><span v-if="authUserInfo">{{ authUserInfo.realName }}</span></span
          >
        </a-dropdown>
      </div>

      <!-- <div class="setMenu" v-show="isMenuShow">
        <div class="setTitle">全局配置</div>
        <div class="mapstyleMenu">
          地图样式:
          <a-select
            v-model="mapThemeValue"
            @change="setMapTheme"
            style="width: 115px; background-color: #fff"
          >
            <a-select-option value="default">蓝黑地图</a-select-option>
            <a-select-option value="normal">彩色地图</a-select-option>
            <a-select-option value="secret">保密地图</a-select-option>
          </a-select>
        </div>
      </div> -->
    </div>
  </a-layout-header>
</template>
<script>
import { mapState } from "vuex";
import { GetQueryString } from "@/utils/utils";
export default {
  name: "Header",
  data() {
    return {
      fullscreen: false,
      isMenuShow: false,
      visible: true,
      isTipShow: false,
      update_time: "--"
    };
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "projectInfo",
      "alarms_data",
      "userMenuPower",
      "projectInfo",
      "pageTitle"
    ]),
    isTouchMode() {
      return GetQueryString("mode") === "touch";
    },
    isShowUpdatePassword() {
      return (
        this.userMenuPower &&
        this.userMenuPower.controls &&
        this.userMenuPower.controls.passwordChange
      );
    },
    isShowProjectConfig() {
      return (
        this.userMenuPower &&
        this.userMenuPower.controls &&
        this.userMenuPower.controls.correlationAnalysisConfig
      );
    }
  },
  mounted() {
    // 有密码提示功能权限再去判断是否给与提醒
    // if (this.isShowUpdatePassword) {
    //   this.isTipShow = this.judgeTipShow();
    //   // 上次修改密码时间
    //   this.update_time = this.$moment(
    //     this.userInfo.user_extension_operate.update_time
    //   ).format("YYYY-MM-DD HH:mm:ss");
    // }
  },
  methods: {
    handleClick() {
      this.isMenuShow = !this.isMenuShow;
    },
    logout() {
      this.$logout();
    },
    toClickMode() {
      document.location.href =
        document.location.origin + document.location.pathname;
      // document.location.href = "/pc/main/index.html";
    },
    toTouchMode() {
      // document.location.href = "/pc/main/index.html?mode=touch";
      document.location.href =
        document.location.origin + document.location.pathname + "?mode=touch";
    },
    fullScreen() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        var el = document.documentElement;
        var rfs =
          el.requestFullScreen ||
          el.webkitRequestFullScreen ||
          el.mozRequestFullScreen ||
          el.msRequestFullscreen;
        if (typeof rfs != "undefined" && rfs) {
          rfs.call(el);
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        }
      }
    },
    updatePassword() {
      this.$refs.updatePassword.isShowInputKey = true;
    },
    judgeTipShow() {
      const user_extension_operate = this.userInfo.user_extension_operate;
      // 设置提醒的对象为空，不提示，有则进行条件判断
      if (user_extension_operate) {
        // 1.当月天数大于设置的提醒日期
        const remind_day = user_extension_operate.remind_day;
        const is_great_remind_day = new Date().getDate() > remind_day;
        // 2.密码修改时间小于设置的提醒日期
        let update_time = this.$moment(
          user_extension_operate.update_time
        ).format("YYYY-MM-DD");
        let current_day = this.$moment().format(`YYYY-MM-${remind_day}`);
        const is_less_update_time = update_time < current_day;
        // 3.当前时间不在不再提醒的时间内
        const no_remind = localStorage.getItem("NO_REMIND");
        let is_include_no_remind = false;
        // 判断是否选择了不再提醒
        if (no_remind) {
          const c = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          is_include_no_remind = Boolean(
            c > no_remind.start && c < no_remind.end
          );
          // 没有选择不再提醒
        } else {
          is_include_no_remind = true;
        }
        // 满足以上三个条件给与提醒，否则不提醒
        if (
          is_great_remind_day &&
          is_less_update_time &&
          is_include_no_remind
        ) {
          return true;
        } else {
          return false;
        }
        // 没有配置提醒，不给与提醒
      } else {
        return false;
      }
    },
    enterConfigPage() {
      this.$router.push({ name: "ProjectConfig" });
    }
  }
};
</script>

<style lang="less">
.header {
  height: 64px;
  /*background-color: #1096F7 !important*/
  background-color: #085e9b !important;
}
.user-info {
  float: right;
  font-size: 16px;
}
.logout-btn {
  font-size: 14px;
  color: white;
  margin-left: 30px;
}
.logout-btn:hover {
  color: #ccc;
}
.title {
  width: 100%;
  font-size: 25px;
  color: white;
  display: inline-block;
}
.setMenu {
  position: absolute;
  z-index: 1000;
  right: 132px;
  width: 202px;
  height: 98px;
  background-color: #fff;
  border-radius: 3px;
  .setTitle {
    height: 40px;
    background-color: #d6eeff;
    line-height: 40px;
    width: 100%;
    font-size: 16px;
    color: #333;
    text-indent: 10px;
  }
  .mapstyleMenu {
    height: 58px;
    line-height: 58px;
    width: 100%;
    font-size: 16px;
    color: #333;
    text-indent: 10px;
    white-space: nowrap;
  }
}
.menu-item {
  cursor: pointer;
  height: 100%;
  width: auto;
  display: inline-block;
  padding: 0 10px;
  &:hover {
    background-color: #065288;
  }
}
</style>
